import { useEffect, useState } from 'react';

import { useDebounce } from '@mint-lib/hooks';
import { useTranslation } from '@mint-lib/i18n';

import { CurrencyField, NumberField } from '@myn/mui';

import { Currency } from '../../../types/_campaigns/campaigns.js';

type Props = {
  value: number | null;
  onChange: (value: number | null) => void;
  currency?: Currency;
};

const DELAY_MS = 500;
export const isZeroValueIgnoringDecimals = (value: string | number) =>
  /^0*\.?0+$/g.test(String(value));

const BudgetField = ({ value, onChange, currency }: Props) => {
  const { t } = useTranslation('@myn/planning');
  const [localValue, setLocalValue] = useState<number | null>(value);
  const localValueDebounced = useDebounce(localValue, DELAY_MS);

  const handleChange = (newValue: number | null) => {
    setLocalValue(newValue);
  };

  useEffect(() => {
    if (value !== localValueDebounced) {
      onChange(localValueDebounced);
    }
  }, [value, localValueDebounced]);

  if (currency) {
    return (
      <CurrencyField
        currency={currency.value}
        value={localValue}
        onChange={handleChange}
        restFormatProps={{
          min: 0,
        }}
        label={t('Budget *')}
        size="small"
        fullWidth
      />
    );
  }

  return (
    <NumberField
      value={localValue}
      onChange={handleChange}
      restFormatProps={{
        min: 0,
      }}
      label={t('Budget *')}
      size="small"
      fullWidth
    />
  );
};

export default BudgetField;
